import React from 'react';
import * as d3Scale from 'd3-scale';
import * as d3Interpolate from 'd3-interpolate';
import Title from './Title';
import DataMap from './DataMap';
import MapLegend from './MapLegend';
var DEFAULT_WIDTH = 400;
var MapElements = function (props) {
    var svgWidth = DEFAULT_WIDTH;
    var svgHeight = svgWidth;
    var mapLayout = props.mapLayout, extremeValues = props.extremeValues, regionData = props.regionData;
    var noDataColor = mapLayout.noDataColor, borderColor = mapLayout.borderColor, hoverColor = mapLayout.hoverColor, startColor = mapLayout.startColor, endColor = mapLayout.endColor, hoverBorderColor = mapLayout.hoverBorderColor;
    var minValue = extremeValues.min, maxValue = extremeValues.max;
    var svgStyle = {
        display: 'inline-block',
        position: 'absolute',
        top: 0,
        left: 0,
    };
    var colorScale = d3Scale
        .scaleLinear()
        .domain([minValue, maxValue])
        // @ts-ignore
        .range([startColor, endColor])
        // @ts-ignore
        .interpolate(d3Interpolate.interpolateLab);
    var mapLegend = (React.createElement(MapLegend, { svgWidth: svgWidth, svgHeight: svgHeight, extremeValues: extremeValues, mapLayout: mapLayout }));
    var isNotExtremeValuesEmpty = !isNaN(minValue) &&
        !isNaN(maxValue) &&
        isFinite(minValue) &&
        isFinite(maxValue);
    return (React.createElement("svg", { style: svgStyle, preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 400 400" },
        React.createElement("g", { id: "root-svg-group" },
            React.createElement(Title, { text: props.mapLayout.title, className: "map-title", coords: { x: 30, y: 40 } }),
            React.createElement(DataMap, { topoData: props.topoData, regionData: regionData, svgWidth: svgWidth, svgHeight: svgHeight, colorScale: colorScale, noDataColor: noDataColor, borderColor: borderColor, hoverColor: hoverColor, hoverBorderColor: hoverBorderColor, mouseMoveOnDatamap: props.mouseMoveOnDatamap, mouseEnterOnDatamap: props.mouseEnterOnDatamap, mouseLeaveDatamap: props.mouseLeaveDatamap, mouseEnterOnState: props.mouseEnterOnState }),
            React.createElement(Title, { text: props.mapLayout.legendTitle, className: "legend-title", coords: { x: svgWidth - 190, y: svgHeight - 35 } }),
            isNotExtremeValuesEmpty && mapLegend)));
};
var arePropsEqual = function (prevProps, nextProps) {
    return (prevProps.infoWindowPos.x === nextProps.infoWindowPos.x &&
        prevProps.infoWindowPos.y === nextProps.infoWindowPos.y &&
        prevProps.regionData === nextProps.regionData);
};
export default React.memo(MapElements, arePropsEqual);
